import { TrackEvent } from '@bnnvara/analytics';
import { BaseButton } from '@bnnvara/buttons';
import { Heading, Text } from '@bnnvara/typography';
import Link from 'next/link';
import React from 'react';

import * as S from './styled';

const DonationSuccess = () => (
  <S.Wrapper align="center">
    <Heading element="h2" variant="two" textTransform="none" textAlign="center">
      Beste donateur,
    </Heading>
    <Text center>
      <br />
      Hartelijk dank voor je donatie! Met jouw donatie kunnen we de programma’s
      blijven maken die je van ons gewend bent!
    </Text>
    <S.Image
      src="../../../static/statusImages/donate_success.gif"
      alt="Het doneren is gelukt"
    />
    <Link href="/jaaroverzicht" passHref>
      <BaseButton
        fullWidth
        type="link"
        onClick={() => TrackEvent('donatie-gelukt', 'click', 'naar-bnnvara.nl')}
      >
        Naar het jaaroverzicht van BNNVARA
      </BaseButton>
    </Link>
  </S.Wrapper>
);

export default DonationSuccess;
